// ##### 25-05-16 Komarov
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText';
// ##### 25-05-16 Komarov
import {
  bookingFromCart,
  getPaymentVoucher,
  getPaymentInfo,
} from '../../../Redux/actions';
import { compose } from '../../../Redux/helpers';
import { withPaymentService } from '../../HOC';
// ##### 25-05-21 Komarov
import CartDetails from '../BookingForm/CartDetails';

// ##### 23-09-14 Komarov
// import './CartDetailsSummary.css'
import { Redirect } from 'react-router';
// ##### 25-05-21 Komarov
import CupOfCoffee from '../../Library/PageDevices/Animation/CupOfCoffee';
import { useSelector } from 'react-redux';

// ##### 25-05-20 Komarov
const PaymentResult = ({
  paymentInfo,
  bookingInfo,
  voucherData,
  getPaymentInfo,
  bookingFromCart,
  getPaymentVoucher,
}) => {
  const [paymentAbsent, setPaymentAbsent] = useState();
  const isPaymentAbsent = paymentInfo?.[0].warnings[0].payment;
  useEffect(() => {
    // ##### 25-05-16 Komarov
    getPaymentInfo();
    if (isPaymentAbsent === 'absent') {
      setPaymentAbsent(true);
      return;
    }
    if (!paymentAbsent) {
      bookingFromCart();
    }
    // bookingFromCart();
  }, [paymentAbsent]);

  // ##### 25-05-20 Komarov
  const smart_service_id = bookingInfo?.[0].data.smart_service_id;
  const smart_reference = paymentInfo?.[0].data.smart_reference;
  useEffect(() => {
    smart_service_id &&
      smart_reference &&
      getPaymentVoucher(smart_service_id, smart_reference);
  }, [smart_service_id, smart_reference]);
  // ##### 24-03-21 Komarov
  const orderId = paymentInfo?.[0].data.customer_reference;
  // ##### 23-03-29 Komarov
  const openInNewTab = url => {
    // ##### 25-05-15 Komarov: доделываем URL ваучера
    const partToRemove = '/var/www/html/hotels-ua.biz/';
    const filePath = url.slice(url.indexOf(partToRemove) + partToRemove.length);
    const newWindow = window.open(
      `${process.env.REACT_APP_SMART_URL}${filePath}`,
      '_blank',
      'noopener,noreferrer'
    );
    if (newWindow) newWindow.opener = null;
  };
  // ##### Komarov 2025-08-05
  const ThankYou = useLocalizedText('ThankYou');
  const CustomerReference = useLocalizedText('CustomerReference');
  const ClickHere = useLocalizedText('ClickHere');
  const GetVoucher = useLocalizedText('GetVoucher');
  const ReservationConfirmed = useLocalizedText('ReservationConfirmed');

  // ##### 25-05-20 Komarov
  const handleClick = () => {
    openInNewTab(voucherData.data.voucherUrl);
  };

  if (paymentInfo === null) {
    return (
      <div data-component="PaymentResult">
        {/* ##### 23-09-07 Komarov: TODO: Сделать сюда перевод текста на разные языки */}
        <div>
          <CupOfCoffee />
        </div>
      </div>
    );
  }

  // ##### 25-05-16 Komarov
  if (paymentInfo && paymentAbsent) {
    const lastLocation = localStorage.getItem('lastLocation');
    return <Redirect to={lastLocation} />;
  }
  // ##### 24-03-21 Komarov
  return (
    <div
      data-component="PaymentResult"
      style={{
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '2vh',
        marginBottom: '3vh',
      }}
    >
      {/* ##### 23-12-27 Komarov: TODO: взять переводы из Смарта */}
      <div className="VoucherText">
        <h4 style={{ marginRight: '5px' }}>{ThankYou}</h4>
        <h4 style={{ marginRight: '5px' }}>{ReservationConfirmed}.</h4>
        {/* ##### 23-12-27 Komarov */}
        {/* <h4 style={{marginRight: '5px'}}> Your booking ID is {orderId}.</h4> */}
        <h4 style={{ marginRight: '5px' }}>
          {' '}
          {CustomerReference} {orderId}.
        </h4>
        <h4 style={{ marginRight: '5px' }}>{ClickHere} </h4>
        {/* ##### 24-03-21 Komarov */}
        <button
          type="submit"
          style={{
            backgroundColor: '#337ab7',
            color: '#fff',
            borderColor: '#2e6da4',
            border: '1px solid transparent',
            borderRadius: '4px',
            padding: '6px 12px',
            cursor: 'pointer',
          }}
          onClick={handleClick}
        >
          {GetVoucher}
        </button>
      </div>

      { /* ##### Komarov 2025-07-21 */}
      <CartDetails cartClass={'CartDetailsSummary'} />
    </div>
  );
};

const mapStateToProps = ({ payment, voucher }) => {
  // ##### Komarov 2025-07-21
  const { paymentInfo, bookingInfo } = payment;
  const { voucherData } = voucher;

  // ##### 25-05-20 Komarov
  return { paymentInfo, bookingInfo, voucherData };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { paymentService } = ownProps;
  return {
    // ##### 23-12-22 Komarov
    bookingFromCart: bookingFromCart(paymentService, dispatch),
    getPaymentInfo: getPaymentInfo(paymentService, dispatch),
    // ##### 25-05-16 Komarov
    getPaymentVoucher: getPaymentVoucher(paymentService, dispatch),
  };
};

export default compose(
  withPaymentService(),
  connect(mapStateToProps, mapDispatchToProps)
)(PaymentResult);
